import styled from 'styled-components'

const Wrapper = styled.section`
  margin-top: 3rem;

  .header{
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  .header h5{
    text-transform: none;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .header .btn{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 0.5rem;
    box-shadow: var(--shadow-2);
    text-transform: none;
  }

  h2 {
    text-transform: none;
  }
  & > h5 {
    font-weight: 700;
  }
  .jobs {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 2rem;
  }

  @media (min-width: 992px) {
    .jobs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }
  }
`
export default Wrapper
